const { populate } = require('@/functions/objects');
const { toString } = require('@/functions/transform');

/**
 * Seat numbers are returned from the API attached to item instances.
 * Each seat number is an object containing a string. This is that object.
 */
class SeatNumber {
    constructor(data = {}) {
        /**
         * @type {string}
         */
        this.seatNumber = '';

        populate(this, data);
    }

    getHydrationMap() {
        return {
            seatNumber: toString,
        };
    }
}

module.exports = SeatNumber;
